import en from "./english.json";

export const translationsForUsersLocale: { [id: string]: string } = ((en) => {
  let x:{[id:string]:string} = {};
  for (const [key, value] of Object.entries(en)) {
    x[key] = value.message;
  }
  return x;
})(en);
